import { ActionReducer, Action } from '@ngrx/store';
import { initialPortalDirectorsListState, IPortalDirectorsListState } from '../states/portal-directors-list.state';
import {
  EPortalDirectorsListActions,
  SetPortalDirectorsSearchFilter,
  SetPortalDirectorsPagination,
  SetPortalDirectorsSort
} from '../actions/portal-directors-list.actions';

export const portalDirectorsListReducers: ActionReducer<IPortalDirectorsListState, Action<string>> = (
  state = initialPortalDirectorsListState,
  action: Action<string>
) => {
  switch (action.type) {
    case EPortalDirectorsListActions.SetSearchFilter: {
      const typedAction = action as SetPortalDirectorsSearchFilter;
      return {
        ...state,
        searchFilter: typedAction.payload,
        currentPage: 1
      };
    }

    case EPortalDirectorsListActions.SetPagination: {
      const typedAction = action as SetPortalDirectorsPagination;
      return {
        ...state,
        currentPage: typedAction.payload.currentPage,
        pageSize: typedAction.payload.pageSize
      };
    }

    case EPortalDirectorsListActions.SetSort: {
      const typedAction = action as SetPortalDirectorsSort;
      return {
        ...state,
        sortBy: typedAction.payload.sortBy,
        ascending: typedAction.payload.ascending
      };
    }

    case EPortalDirectorsListActions.ClearFilters: {
      return { ...initialPortalDirectorsListState };
    }

    default:
      return state;
  }
};
